// extracted by mini-css-extract-plugin
export default {"expired-survey-card-layout":"styles-module_expired-survey-card-layout---eg8LZ"};